<template>
  <div>
    Waiting
  </div>
</template>
<script setup>
import {onMounted} from "vue";
import OAuthService from "@/utilities/services/OAuthService";
import {useGlobalStore} from "@/stores/GlobalStore";
import {disdiClientConfig} from "@/AppConfig";

const globalStore = useGlobalStore();

onMounted(async ()=> {
  const oAuthService = new OAuthService(globalStore.getAuthorityUrl(), disdiClientConfig.clientId, disdiClientConfig.scopes, disdiClientConfig.callback, disdiClientConfig.silent); //TODO configure correctly  
  try {
    await oAuthService.refreshTokensSilently();
  }
  catch (e) {
    console.error(e);
    return;
  }
})

</script>
